import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PerfilService {
    
           
    private readonly apiUrl = environment.apiEndpoint + 'perfil';

    constructor(private http:HttpClient) {}


    getPerfiles( idCliente: any ) : Observable<any[]>{
        let finalurl = this.apiUrl + "/cliente/" + idCliente
        return this.http.get<any[]>(finalurl, { withCredentials: true });
    }

    getPerfilByIdTarjeta(idTarjeta: number) : Observable<any>{
        let finalurl = this.apiUrl + "/tarjeta/" + idTarjeta
        return this.http.get<any>(finalurl, { withCredentials: true });
    }

    getPerfilByCodeTarjeta(codigo: any) : Observable<any>{
        let finalurl = this.apiUrl + "/tarjeta/codigo/" + codigo
        return this.http.get<any>(finalurl, { withCredentials: true });
    }

    getPerfilByID(perfilId: string) : Observable<any>{
        let finalurl = this.apiUrl + "/" + perfilId
        return this.http.get<any>(finalurl, { withCredentials: true });
    }

    createPerfil(perfilData: FormData) : Observable<any> {
        return this.http.post(this.apiUrl, perfilData); 
    }

    updatePerfil(perfilData: FormData) : Observable<any> {
        return this.http.put(this.apiUrl, perfilData); 
    }

    deletePerfil(id: number) : Observable<any> {
        return this.http.delete(this.apiUrl + '/' + id, { withCredentials: true });
    }

}
